import { Flex, FlexProps, Spacer } from '@chakra-ui/react'
import { ReactNode } from 'react'
import { HelpHover, Text, Tooltip } from '.'
import { ExclamationCircleIcon } from './icons'

export interface Props extends FlexProps {
  helpHover?: string
  label?: string | ReactNode
  labelActions?: JSX.Element
  required?: boolean
  isError?: boolean
}

export default function InputContainer({
  children,
  helpHover,
  label,
  labelActions,
  isError,
  required,
  ...rest
}: Props) {
  return (
    <Flex direction="column" gap={2} {...rest}>
      {typeof label === 'string' ? (
        <Flex gap={2} align="center" color={isError ? 'danger.500' : undefined}>
          <Text textStyle="bodySmall" opacity={0.7}>
            {label}
          </Text>

          {helpHover && (
            <HelpHover
              iconProps={{ size: 'sm' }}
              positioning={{ placement: 'right' }}
              text={helpHover}
            />
          )}

          {required && (
            <Tooltip content="This field is required" positioning={{ placement: 'right' }}>
              <ExclamationCircleIcon type="outline" size="sm" />
            </Tooltip>
          )}

          <Spacer />

          {labelActions || null}
        </Flex>
      ) : (
        label
      )}

      {children}
    </Flex>
  )
}
